import InsideSalesListTable from './InsideSalesListTable';

export default InsideSalesListTable;
